import { takeLatest, call, put, fork, all } from 'redux-saga/effects';
import { loadMalzeme, saveMalzeme } from 'src/utils/storage/Material';
import { distinct } from 'src/utils/Common';
import * as actions from '../actions/materialActions';
import * as alertActions from '../actions/alertActions';
import * as api from '../api/afterSalesDataServices';

function* getMaterials(params, WorkOrderMaterials) {
  try {
    if (!params.kulModelKodu) {
      throw new Error('Model Kodu Girilmemiş');
    }
    let data = loadMalzeme(params.kulModelKodu);

    const result = yield call(api.getMaterials, params);
    data = result.data === '' ? [] : result.data;
    saveMalzeme(params.kulModelKodu, data);
    let selectedMaterials = {};
    var { WorkOrderMaterials } = arguments[0];

    if (data.length > 0) {
      if (WorkOrderMaterials) {
        const DistinctMaterial = distinct(
          WorkOrderMaterials.map(w => {
            return { DefectId: w.DefectId };
          })
        );
        DistinctMaterial.forEach(function(h, index) {
          selectedMaterials = { ...selectedMaterials, [h.DefectId]: [] };
        });

        WorkOrderMaterials.forEach(function(i, index) {
          selectedMaterials[i.DefectId].push(i.MaterialCode.toString());
          selectedMaterials = {
            ...selectedMaterials,
            [i.MaterialCode]: i.Count
          };

          var tempIndex = data.findIndex(f=>f.MaterialId === i.MaterialId);
          if(tempIndex !== -1){
          const updatedItem = { ...data[tempIndex] };
            updatedItem.Price = i.MaterialPrice;
            updatedItem.PriceWithWat =i.MaterialPriceWithWat;

            data[tempIndex] = updatedItem;
          }
        });
      }
    }

    yield put(actions.getMaterialSuccess(data, selectedMaterials));
  } catch (error) {
    yield put(actions.setMaterialError(error));
  }
}

function* watchGetMaterialRequest() {
  yield takeLatest(actions.Types.GET_MATERIAL_REQUEST, getMaterials);
}

function* getHistoricalMaterials(params) {
  try {
    if (!params.kulModelKodu) {
      throw new Error('Model Kodu Girilmemiş');
    }
    let data = [];
    let alertMessage =
      'Internet bağlantınız olmadığı için tarihsel ağaç verisi alınamadı!..';
    if (window.navigator.onLine) {
      const result = yield call(api.getHistoricalMaterials, params);
      data = result.data === '' ? [] : result.data;
      const count = data.filter(d => d.HistoricalBom === 1).length;
      alertMessage =
        count === 0
          ? 'Ürüne ait Tarihsel Ağaç Yok!...'
          : 'Ürüne ait Tarihsel Ağaç Verisi Alındı.';
      saveMalzeme(params.kulModelKodu, data);
    }
    yield all([
      put(actions.getMaterialSuccess(data, '')),
      put(alertActions.setAlert(alertMessage, 'Bilgilendirme'))
    ]);
  } catch (error) {
    yield put(actions.setMaterialError(error));
  }
}

function* watchGetHistoricalMaterialRequest() {
  yield takeLatest(
    actions.Types.GET_HISTORICAL_MATERIAL_REQUEST,
    getHistoricalMaterials
  );
}

const materialSagas = [
  fork(watchGetMaterialRequest),
  fork(watchGetHistoricalMaterialRequest)
];

export default materialSagas;
